import r from"../../icons/AlignLeftIcon.js";import m from"../../icons/AlignCenterIcon.js";import o from"../../icons/AlignRightIcon.js";import"react";const i=t=>t==="rtl"?"RIGHT":"LEFT",p={LEFT:r,CENTER:m,RIGHT:o};export{p as alignmentMap,i as getDefaultAlignment};
//# sourceMappingURL=utils.js.map
